function InvalidLinkErrorWrapper() {
    $("#main-view").html("<div id='invalid-link-error'></div>");
    const invalidLinkErrorComponent = React.createElement(window.reactComponents.InvalidLinkErrorWrapper);
    ReactDOM.render(invalidLinkErrorComponent, document.querySelector('#invalid-link-error'));
}

EG.Users.Presenters.InvalidLinkErrorWrapper = InvalidLinkErrorWrapper;
